import { defineStore } from "pinia";

export const useComplaintRequestStore = defineStore("complaintRequest", {
  state: () => ({
    relatedDepartments: [
      "Üretim",
      "Lojistik",
      "Bilgi İşlem",
      "Operasyon",
      "Muhasebe",
      "Finans",
      "İdari İşler",
      "Satınalma",
    ],
  }),
});
